import React from 'react';
import PropTypes from 'prop-types';
import { ExportProgressBarWithRedux } from 'ExportProgressBar';
import withInit from 'WithInit';
import BaseModal from 'Modals/BaseModal';

// Export progress modal does not close, but `BaseModal` requires a `closeModal`
// method prop and calls it, which is why we have an empty method passed in
export const ExportProgressBarModal = props => (
  <BaseModal
    modalType="export-progress-bar-modal"
    activeModal="export-progress-bar-modal"
    ariaHideApp={false}
    modalClass="progress-modal"
    closeModal={() => {}}
    modalBodyClass="modal-content"
    bodyContent={<ExportProgressBarWithRedux href={props.href} callback={props.callback} />}
  />
);

ExportProgressBarModal.propTypes = {
  href: PropTypes.string.isRequired,
  callback: PropTypes.func,
};

ExportProgressBarModal.defaultProps = {
  callback: null,
};

export default withInit(ExportProgressBarModal, true);



// WEBPACK FOOTER //
// ./src-react/Modals/ExportProgressBarModal/index.jsx